//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AllocationSystemsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all enabled allocation systems
     * @return OK
     */
    getAllocationSystems( cancelToken?: CancelToken): Promise<AllocationSystemGet[]> {
        let url_ = this.baseUrl + "/v1/core/allocation-systems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllocationSystems(_response);
        });
    }

    protected processGetAllocationSystems(response: AxiosResponse): Promise<AllocationSystemGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AllocationSystemGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllocationSystemGet[]>(null as any);
    }

    /**
     * Update allocation system (only current time frame at the moment)
     * @return OK
     */
    updateAllocationSystem(allocationSystemId: AllocationSystems, body: AllocationSystemUpdate, cancelToken?: CancelToken): Promise<AllocationSystemGet> {
        let url_ = this.baseUrl + "/v1/core/allocation-systems/{allocationSystemId}";
        if (allocationSystemId === undefined || allocationSystemId === null)
            throw new Error("The parameter 'allocationSystemId' must be defined.");
        url_ = url_.replace("{allocationSystemId}", encodeURIComponent("" + allocationSystemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAllocationSystem(_response);
        });
    }

    protected processUpdateAllocationSystem(response: AxiosResponse): Promise<AllocationSystemGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AllocationSystemGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllocationSystemGet>(null as any);
    }
}

export class BrandsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a brand
     * @param body Brand to create
     * @return Created
     */
    createBrand(body: BrandCreateOrUpdate, cancelToken?: CancelToken): Promise<BrandGet> {
        let url_ = this.baseUrl + "/v1/core/brands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBrand(_response);
        });
    }

    protected processCreateBrand(response: AxiosResponse): Promise<BrandGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<BrandGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandGet>(null as any);
    }

    /**
     * Get all brands
     * @return OK
     */
    getBrands( cancelToken?: CancelToken): Promise<BrandGet[]> {
        let url_ = this.baseUrl + "/v1/core/brands";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrands(_response);
        });
    }

    protected processGetBrands(response: AxiosResponse): Promise<BrandGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BrandGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandGet[]>(null as any);
    }

    /**
     * Get brand with given id
     * @param brandId Identifier of the brand
     * @return OK
     */
    getBrand(brandId: number, cancelToken?: CancelToken): Promise<BrandGet> {
        let url_ = this.baseUrl + "/v1/core/brands/{brandId}";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBrand(_response);
        });
    }

    protected processGetBrand(response: AxiosResponse): Promise<BrandGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BrandGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandGet>(null as any);
    }

    /**
     * Update a brand
     * @param brandId Brand identifier
     * @param body Brand to update
     * @return OK
     */
    updateBrand(brandId: number, body: BrandCreateOrUpdate, cancelToken?: CancelToken): Promise<BrandGet> {
        let url_ = this.baseUrl + "/v1/core/brands/{brandId}";
        if (brandId === undefined || brandId === null)
            throw new Error("The parameter 'brandId' must be defined.");
        url_ = url_.replace("{brandId}", encodeURIComponent("" + brandId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBrand(_response);
        });
    }

    protected processUpdateBrand(response: AxiosResponse): Promise<BrandGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BrandGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrandGet>(null as any);
    }
}

export class EntitiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create an entity
     * @param body entity to create
     * @return Created
     */
    createEntity(body: EntityCreateOrUpdate, cancelToken?: CancelToken): Promise<EntityGet> {
        let url_ = this.baseUrl + "/v1/core/entities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEntity(_response);
        });
    }

    protected processCreateEntity(response: AxiosResponse): Promise<EntityGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<EntityGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityGet>(null as any);
    }

    /**
     * Get all entities
     * @return OK
     */
    getEntities( cancelToken?: CancelToken): Promise<EntityGet[]> {
        let url_ = this.baseUrl + "/v1/core/entities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntities(_response);
        });
    }

    protected processGetEntities(response: AxiosResponse): Promise<EntityGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityGet[]>(null as any);
    }

    /**
     * Get entity with given id
     * @param entityId Identifier of the entity
     * @return OK
     */
    getEntity(entityId: number, cancelToken?: CancelToken): Promise<EntityGet> {
        let url_ = this.baseUrl + "/v1/core/entities/{entityId}";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEntity(_response);
        });
    }

    protected processGetEntity(response: AxiosResponse): Promise<EntityGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityGet>(null as any);
    }

    /**
     * Update an entity
     * @param entityId entity identifier
     * @param body entity to update
     * @return OK
     */
    updateEntity(entityId: number, body: EntityCreateOrUpdate, cancelToken?: CancelToken): Promise<EntityGet> {
        let url_ = this.baseUrl + "/v1/core/entities/{entityId}";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEntity(_response);
        });
    }

    protected processUpdateEntity(response: AxiosResponse): Promise<EntityGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EntityGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityGet>(null as any);
    }
}

export class FiscalYearsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get all fiscal years
     * @return OK
     */
    getFiscalYears( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/v1/core/fiscal-years";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFiscalYears(_response);
        });
    }

    protected processGetFiscalYears(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class ImportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Upload import file (will trigger Azure Function)
     * @param allocationSystemId (optional) 
     * @param fiscalYear (optional) 
     * @param fileFolder (optional) 
     * @param file (optional) 
     * @return OK
     */
    createImport(allocationSystemId?: AllocationSystems | undefined, fiscalYear?: number | undefined, fileFolder?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/v1/core/imports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (allocationSystemId === null || allocationSystemId === undefined)
            throw new Error("The parameter 'allocationSystemId' cannot be null.");
        else
            content_.append("AllocationSystemId", allocationSystemId.toString());
        if (fiscalYear === null || fiscalYear === undefined)
            throw new Error("The parameter 'fiscalYear' cannot be null.");
        else
            content_.append("FiscalYear", fiscalYear.toString());
        if (fileFolder === null || fileFolder === undefined)
            throw new Error("The parameter 'fileFolder' cannot be null.");
        else
            content_.append("FileFolder", fileFolder.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateImport(_response);
        });
    }

    protected processCreateImport(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get import by using file identifier
     * @param fileId File identifier
     * @return OK
     */
    getImport(fileId: number, cancelToken?: CancelToken): Promise<ImportGet> {
        let url_ = this.baseUrl + "/v1/core/imports/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImport(_response);
        });
    }

    protected processGetImport(response: AxiosResponse): Promise<ImportGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ImportGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportGet>(null as any);
    }
}

export class MarketsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a market
     * @param body Market to create
     * @return Created
     */
    createMarket(body: MarketCreateOrUpdate, cancelToken?: CancelToken): Promise<MarketGet> {
        let url_ = this.baseUrl + "/v1/core/markets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMarket(_response);
        });
    }

    protected processCreateMarket(response: AxiosResponse): Promise<MarketGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<MarketGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketGet>(null as any);
    }

    /**
     * Get all markets
     * @return OK
     */
    getMarkets( cancelToken?: CancelToken): Promise<MarketGet[]> {
        let url_ = this.baseUrl + "/v1/core/markets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMarkets(_response);
        });
    }

    protected processGetMarkets(response: AxiosResponse): Promise<MarketGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MarketGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketGet[]>(null as any);
    }

    /**
     * Get market with given id
     * @param marketId Identifier of the market
     * @return OK
     */
    getMarket(marketId: number, cancelToken?: CancelToken): Promise<MarketGet> {
        let url_ = this.baseUrl + "/v1/core/markets/{marketId}";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined.");
        url_ = url_.replace("{marketId}", encodeURIComponent("" + marketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMarket(_response);
        });
    }

    protected processGetMarket(response: AxiosResponse): Promise<MarketGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MarketGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketGet>(null as any);
    }

    /**
     * Update a market
     * @param marketId Market identifier
     * @param body Market to update
     * @return OK
     */
    updateMarket(marketId: number, body: MarketCreateOrUpdate, cancelToken?: CancelToken): Promise<MarketGet> {
        let url_ = this.baseUrl + "/v1/core/markets/{marketId}";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined.");
        url_ = url_.replace("{marketId}", encodeURIComponent("" + marketId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMarket(_response);
        });
    }

    protected processUpdateMarket(response: AxiosResponse): Promise<MarketGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MarketGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarketGet>(null as any);
    }
}

export class OrganizationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create an organization
     * @param body organization to create
     * @return Created
     */
    createOrganization(body: OrganizationCreateOrUpdate, cancelToken?: CancelToken): Promise<OrganizationGet> {
        let url_ = this.baseUrl + "/v1/core/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrganization(_response);
        });
    }

    protected processCreateOrganization(response: AxiosResponse): Promise<OrganizationGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<OrganizationGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationGet>(null as any);
    }

    /**
     * Get all organizations
     * @return OK
     */
    getOrganizations( cancelToken?: CancelToken): Promise<OrganizationGet[]> {
        let url_ = this.baseUrl + "/v1/core/organizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: AxiosResponse): Promise<OrganizationGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationGet[]>(null as any);
    }

    /**
     * Get organization with given id
     * @param organizationId Identifier of the organization
     * @return OK
     */
    getOrganization(organizationId: number, cancelToken?: CancelToken): Promise<OrganizationGet> {
        let url_ = this.baseUrl + "/v1/core/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganization(_response);
        });
    }

    protected processGetOrganization(response: AxiosResponse): Promise<OrganizationGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationGet>(null as any);
    }

    /**
     * Update an organization
     * @param organizationId organization identifier
     * @param body organization to update
     * @return OK
     */
    updateOrganization(organizationId: number, body: OrganizationCreateOrUpdate, cancelToken?: CancelToken): Promise<OrganizationGet> {
        let url_ = this.baseUrl + "/v1/core/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOrganization(_response);
        });
    }

    protected processUpdateOrganization(response: AxiosResponse): Promise<OrganizationGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OrganizationGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationGet>(null as any);
    }
}

export class ProductsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a RUC product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return Created
     */
    createRucProduct(productCreateOrUpdateData?: ProductCreateOrUpdateData | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<RucProductGet> {
        let url_ = this.baseUrl + "/v1/ruc/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRucProduct(_response);
        });
    }

    protected processCreateRucProduct(response: AxiosResponse): Promise<RucProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<RucProductGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucProductGet>(null as any);
    }

    /**
     * Get paginated RUC product list
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getRucProducts(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<RucProductGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/ruc/products?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRucProducts(_response);
        });
    }

    protected processGetRucProducts(response: AxiosResponse): Promise<RucProductGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucProductGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucProductGetIPaginatedList>(null as any);
    }

    /**
     * Disable or enable product
     * @param productId Product identifier of product to disable/enable
     * @param body (optional) disable/enable product
     * @return No Content
     */
    disableOrEnableRucProduct(productId: number, body?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/v1/ruc/products/{productId}/isDisabled";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableOrEnableRucProduct(_response);
        });
    }

    protected processDisableOrEnableRucProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download excel file with RUC products
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @return OK
     */
    downloadExcelRucProducts(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/ruc/products/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelRucProducts(_response);
        });
    }

    protected processDownloadExcelRucProducts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get RUC product with given id
     * @param productId Identifier of the RUC product
     * @return OK
     */
    getRucProduct(productId: number, cancelToken?: CancelToken): Promise<RucProductGet> {
        let url_ = this.baseUrl + "/v1/ruc/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRucProduct(_response);
        });
    }

    protected processGetRucProduct(response: AxiosResponse): Promise<RucProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucProductGet>(null as any);
    }

    /**
     * Update a RUC product
     * @param productId Identifier of the RUC product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return OK
     */
    updateRucProduct(productId: number, productCreateOrUpdateData?: ProductCreateOrUpdateData2 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<RucProductGet> {
        let url_ = this.baseUrl + "/v1/ruc/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRucProduct(_response);
        });
    }

    protected processUpdateRucProduct(response: AxiosResponse): Promise<RucProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucProductGet>(null as any);
    }

    /**
     * Patch a RUC product (partial update)
     * @param productId Identifier of the RUC product
     * @param body RUC product to patch
     * @return OK
     */
    patchRucProduct(productId: number, body: RucProductPatch, cancelToken?: CancelToken): Promise<RucProductGet> {
        let url_ = this.baseUrl + "/v1/ruc/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchRucProduct(_response);
        });
    }

    protected processPatchRucProduct(response: AxiosResponse): Promise<RucProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucProductGet>(null as any);
    }

    /**
     * Create an OES product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return Created
     */
    createOesProduct(productCreateOrUpdateData?: ProductCreateOrUpdateData3 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<OesProductGet> {
        let url_ = this.baseUrl + "/v1/oes/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOesProduct(_response);
        });
    }

    protected processCreateOesProduct(response: AxiosResponse): Promise<OesProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<OesProductGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesProductGet>(null as any);
    }

    /**
     * Get paginated OES product list
     * @param name (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getOesProducts(fiscalYear: number, name?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<OesProductGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/oes/products?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOesProducts(_response);
        });
    }

    protected processGetOesProducts(response: AxiosResponse): Promise<OesProductGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesProductGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesProductGetIPaginatedList>(null as any);
    }

    /**
     * Disable or enable product
     * @param productId Product identifier of product to disable/enable
     * @param body (optional) disable/enable product
     * @return No Content
     */
    disableOrEnableOesProduct(productId: number, body?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/v1/oes/products/{productId}/isDisabled";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableOrEnableOesProduct(_response);
        });
    }

    protected processDisableOrEnableOesProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download excel file with OES products
     * @param name (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @return OK
     */
    downloadExcelOesProducts(fiscalYear: number, name?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/oes/products/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelOesProducts(_response);
        });
    }

    protected processDownloadExcelOesProducts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get OES product with given id
     * @param productId Identifier of the OES product
     * @return OK
     */
    getOesProduct(productId: number, cancelToken?: CancelToken): Promise<OesProductGet> {
        let url_ = this.baseUrl + "/v1/oes/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOesProduct(_response);
        });
    }

    protected processGetOesProduct(response: AxiosResponse): Promise<OesProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesProductGet>(null as any);
    }

    /**
     * Update an OES product
     * @param productId Identifier of the OES product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return OK
     */
    updateOesProduct(productId: number, productCreateOrUpdateData?: ProductCreateOrUpdateData4 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<OesProductGet> {
        let url_ = this.baseUrl + "/v1/oes/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOesProduct(_response);
        });
    }

    protected processUpdateOesProduct(response: AxiosResponse): Promise<OesProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesProductGet>(null as any);
    }

    /**
     * Patch an OES product (partial update)
     * @param productId Identifier of the OES product
     * @param body OES product to patch
     * @return OK
     */
    patchOesProduct(productId: number, body: OesProductPatch, cancelToken?: CancelToken): Promise<OesProductGet> {
        let url_ = this.baseUrl + "/v1/oes/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchOesProduct(_response);
        });
    }

    protected processPatchOesProduct(response: AxiosResponse): Promise<OesProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesProductGet>(null as any);
    }

    /**
     * Create a LOI product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return Created
     */
    createLoiProduct(productCreateOrUpdateData?: ProductCreateOrUpdateData5 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<LoiProductGet> {
        let url_ = this.baseUrl + "/v1/loi/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLoiProduct(_response);
        });
    }

    protected processCreateLoiProduct(response: AxiosResponse): Promise<LoiProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<LoiProductGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiProductGet>(null as any);
    }

    /**
     * Get paginated LOI product list
     * @param name (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getLoiProducts(fiscalYear: number, name?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<LoiProductGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/loi/products?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoiProducts(_response);
        });
    }

    protected processGetLoiProducts(response: AxiosResponse): Promise<LoiProductGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiProductGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiProductGetIPaginatedList>(null as any);
    }

    /**
     * Disable or enable product
     * @param productId Product identifier of product to disable/enable
     * @param body (optional) disable/enable product
     * @return No Content
     */
    disableOrEnableLoiProduct(productId: number, body?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/v1/loi/products/{productId}/isDisabled";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableOrEnableLoiProduct(_response);
        });
    }

    protected processDisableOrEnableLoiProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download excel file with LOI products
     * @param name (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @return OK
     */
    downloadExcelLoiProducts(fiscalYear: number, name?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/loi/products/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelLoiProducts(_response);
        });
    }

    protected processDownloadExcelLoiProducts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get LOI product with given id
     * @param productId Identifier of the LOI product
     * @return OK
     */
    getLoiProduct(productId: number, cancelToken?: CancelToken): Promise<LoiProductGet> {
        let url_ = this.baseUrl + "/v1/loi/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoiProduct(_response);
        });
    }

    protected processGetLoiProduct(response: AxiosResponse): Promise<LoiProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiProductGet>(null as any);
    }

    /**
     * Update a LOI product
     * @param productId Identifier of the LOI product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return OK
     */
    updateLoiProduct(productId: number, productCreateOrUpdateData?: ProductCreateOrUpdateData6 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<LoiProductGet> {
        let url_ = this.baseUrl + "/v1/loi/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLoiProduct(_response);
        });
    }

    protected processUpdateLoiProduct(response: AxiosResponse): Promise<LoiProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiProductGet>(null as any);
    }

    /**
     * Patch a LOI product (partial update)
     * @param productId Identifier of the LOI product
     * @param body LOI product to patch
     * @return OK
     */
    patchLoiProduct(productId: number, body: LoiProductPatch, cancelToken?: CancelToken): Promise<LoiProductGet> {
        let url_ = this.baseUrl + "/v1/loi/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchLoiProduct(_response);
        });
    }

    protected processPatchLoiProduct(response: AxiosResponse): Promise<LoiProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiProductGet>(null as any);
    }

    /**
     * Create a GAP product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return Created
     */
    createGapProduct(productCreateOrUpdateData?: ProductCreateOrUpdateData7 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<GapProductGet> {
        let url_ = this.baseUrl + "/v1/gap/products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGapProduct(_response);
        });
    }

    protected processCreateGapProduct(response: AxiosResponse): Promise<GapProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<GapProductGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapProductGet>(null as any);
    }

    /**
     * Get paginated GAP product list
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getGapProducts(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<GapProductGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/gap/products?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGapProducts(_response);
        });
    }

    protected processGetGapProducts(response: AxiosResponse): Promise<GapProductGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapProductGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapProductGetIPaginatedList>(null as any);
    }

    /**
     * Disable or enable product
     * @param productId Product identifier of product to disable/enable
     * @param body (optional) disable/enable product
     * @return No Content
     */
    disableOrEnableGapProduct(productId: number, body?: boolean | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/v1/gap/products/{productId}/isDisabled";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDisableOrEnableGapProduct(_response);
        });
    }

    protected processDisableOrEnableGapProduct(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Download excel file with GAP products
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param productIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @return OK
     */
    downloadExcelGapProducts(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, productIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/gap/products/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelGapProducts(_response);
        });
    }

    protected processDownloadExcelGapProducts(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get GAP product with given id
     * @param productId Identifier of the GAP product
     * @return OK
     */
    getGapProduct(productId: number, cancelToken?: CancelToken): Promise<GapProductGet> {
        let url_ = this.baseUrl + "/v1/gap/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGapProduct(_response);
        });
    }

    protected processGetGapProduct(response: AxiosResponse): Promise<GapProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapProductGet>(null as any);
    }

    /**
     * Update a GAP product
     * @param productId Identifier of the GAP product
     * @param productCreateOrUpdateData (optional) See  model.
     * @param files (optional) 
     * @return OK
     */
    updateGapProduct(productId: number, productCreateOrUpdateData?: ProductCreateOrUpdateData8 | undefined, files?: FileParameter[] | undefined, cancelToken?: CancelToken): Promise<GapProductGet> {
        let url_ = this.baseUrl + "/v1/gap/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (productCreateOrUpdateData === null || productCreateOrUpdateData === undefined)
            throw new Error("The parameter 'productCreateOrUpdateData' cannot be null.");
        else
            content_.append("ProductCreateOrUpdateData", JSON.stringify(productCreateOrUpdateData));
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("Files", item_.data, item_.fileName ? item_.fileName : "Files") );

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGapProduct(_response);
        });
    }

    protected processUpdateGapProduct(response: AxiosResponse): Promise<GapProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapProductGet>(null as any);
    }

    /**
     * Patch a GAP product (partial update)
     * @param productId Identifier of the GAP product
     * @param body GAP product to patch
     * @return OK
     */
    patchGapProduct(productId: number, body: GapProductPatch, cancelToken?: CancelToken): Promise<GapProductGet> {
        let url_ = this.baseUrl + "/v1/gap/products/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchGapProduct(_response);
        });
    }

    protected processPatchGapProduct(response: AxiosResponse): Promise<GapProductGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapProductGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapProductGet>(null as any);
    }
}

export class RequestsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a RUC request
     * @param body RUC request to create
     * @return Created
     */
    createRucRequest(body: RucRequestCreate, cancelToken?: CancelToken): Promise<RucRequestGet> {
        let url_ = this.baseUrl + "/v1/ruc/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRucRequest(_response);
        });
    }

    protected processCreateRucRequest(response: AxiosResponse): Promise<RucRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<RucRequestGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucRequestGet>(null as any);
    }

    /**
     * Get paginated RUC request list
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getRucRequests(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<RucRequestGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/ruc/requests?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRucRequests(_response);
        });
    }

    protected processGetRucRequests(response: AxiosResponse): Promise<RucRequestGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucRequestGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucRequestGetIPaginatedList>(null as any);
    }

    /**
     * Download excel file with RUC requests
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @return OK
     */
    downloadExcelRucRequests(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/ruc/requests/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelRucRequests(_response);
        });
    }

    protected processDownloadExcelRucRequests(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get RUC request with given id
     * @param requestId Identifier of the RUC request
     * @return OK
     */
    getRucRequest(requestId: number, cancelToken?: CancelToken): Promise<RucRequestGet> {
        let url_ = this.baseUrl + "/v1/ruc/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRucRequest(_response);
        });
    }

    protected processGetRucRequest(response: AxiosResponse): Promise<RucRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucRequestGet>(null as any);
    }

    /**
     * Patch a RUC request (partial update)
     * @param requestId Identifier of the RUC request
     * @param body RUC request to patch
     * @return OK
     */
    patchRucRequest(requestId: number, body: RucRequestPatch, cancelToken?: CancelToken): Promise<RucRequestGet> {
        let url_ = this.baseUrl + "/v1/ruc/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchRucRequest(_response);
        });
    }

    protected processPatchRucRequest(response: AxiosResponse): Promise<RucRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucRequestGet>(null as any);
    }

    /**
     * Create an OES request
     * @param body OES request to create
     * @return Created
     */
    createOesRequest(body: OesRequestCreate, cancelToken?: CancelToken): Promise<OesRequestGet> {
        let url_ = this.baseUrl + "/v1/oes/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOesRequest(_response);
        });
    }

    protected processCreateOesRequest(response: AxiosResponse): Promise<OesRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<OesRequestGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesRequestGet>(null as any);
    }

    /**
     * Get paginated OES request list
     * @param name (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getOesRequests(fiscalYear: number, name?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<OesRequestGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/oes/requests?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOesRequests(_response);
        });
    }

    protected processGetOesRequests(response: AxiosResponse): Promise<OesRequestGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesRequestGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesRequestGetIPaginatedList>(null as any);
    }

    /**
     * Download excel file with OES requests
     * @param name (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @return OK
     */
    downloadExcelOesRequests(fiscalYear: number, name?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/oes/requests/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelOesRequests(_response);
        });
    }

    protected processDownloadExcelOesRequests(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get OES request with given id
     * @param requestId Identifier of the OES request
     * @return OK
     */
    getOesRequest(requestId: number, cancelToken?: CancelToken): Promise<OesRequestGet> {
        let url_ = this.baseUrl + "/v1/oes/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOesRequest(_response);
        });
    }

    protected processGetOesRequest(response: AxiosResponse): Promise<OesRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesRequestGet>(null as any);
    }

    /**
     * Patch an OES request (partial update)
     * @param requestId Identifier of the OES request
     * @param body OES request to patch
     * @return OK
     */
    patchOesRequest(requestId: number, body: OesRequestPatch, cancelToken?: CancelToken): Promise<OesRequestGet> {
        let url_ = this.baseUrl + "/v1/oes/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchOesRequest(_response);
        });
    }

    protected processPatchOesRequest(response: AxiosResponse): Promise<OesRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesRequestGet>(null as any);
    }

    /**
     * Create a LOI request
     * @param body LOI request to create
     * @return Created
     */
    createLoiRequest(body: LoiRequestCreate, cancelToken?: CancelToken): Promise<LoiRequestGet> {
        let url_ = this.baseUrl + "/v1/loi/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLoiRequest(_response);
        });
    }

    protected processCreateLoiRequest(response: AxiosResponse): Promise<LoiRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<LoiRequestGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiRequestGet>(null as any);
    }

    /**
     * Get paginated LOI request list
     * @param name (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getLoiRequests(fiscalYear: number, name?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<LoiRequestGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/loi/requests?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoiRequests(_response);
        });
    }

    protected processGetLoiRequests(response: AxiosResponse): Promise<LoiRequestGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiRequestGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiRequestGetIPaginatedList>(null as any);
    }

    /**
     * Download excel file with LOI requests
     * @param name (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @return OK
     */
    downloadExcelLoiRequests(fiscalYear: number, name?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/loi/requests/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelLoiRequests(_response);
        });
    }

    protected processDownloadExcelLoiRequests(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get LOI request with given id
     * @param requestId Identifier of the LOI request
     * @return OK
     */
    getLoiRequest(requestId: number, cancelToken?: CancelToken): Promise<LoiRequestGet> {
        let url_ = this.baseUrl + "/v1/loi/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoiRequest(_response);
        });
    }

    protected processGetLoiRequest(response: AxiosResponse): Promise<LoiRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiRequestGet>(null as any);
    }

    /**
     * Patch a LOI request (partial update)
     * @param requestId Identifier of the LOI request
     * @param body LOI request to patch
     * @return OK
     */
    patchLoiRequest(requestId: number, body: LoiRequestPatch, cancelToken?: CancelToken): Promise<LoiRequestGet> {
        let url_ = this.baseUrl + "/v1/loi/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchLoiRequest(_response);
        });
    }

    protected processPatchLoiRequest(response: AxiosResponse): Promise<LoiRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<LoiRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoiRequestGet>(null as any);
    }

    /**
     * Create a GAP request
     * @param body GAP request to create
     * @return Created
     */
    createGapRequest(body: GapRequestCreate, cancelToken?: CancelToken): Promise<GapRequestGet> {
        let url_ = this.baseUrl + "/v1/gap/requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateGapRequest(_response);
        });
    }

    protected processCreateGapRequest(response: AxiosResponse): Promise<GapRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<GapRequestGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapRequestGet>(null as any);
    }

    /**
     * Get paginated GAP request list
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getGapRequests(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<GapRequestGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/gap/requests?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGapRequests(_response);
        });
    }

    protected processGetGapRequests(response: AxiosResponse): Promise<GapRequestGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapRequestGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapRequestGetIPaginatedList>(null as any);
    }

    /**
     * Download excel file with GAP requests
     * @param skuId (optional) 
     * @param skuName (optional) 
     * @param requestIds (optional) 
     * @param productIds (optional) 
     * @param marketIds (optional) 
     * @param brandIds (optional) 
     * @param onlyDisabled (optional) 
     * @param isRequestRequired (optional) 
     * @return OK
     */
    downloadExcelGapRequests(fiscalYear: number, skuId?: string | undefined, skuName?: string | undefined, requestIds?: number[] | undefined, productIds?: number[] | undefined, marketIds?: number[] | undefined, brandIds?: number[] | undefined, onlyDisabled?: boolean | undefined, isRequestRequired?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/gap/requests/download/excel?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "FiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        if (skuId === null)
            throw new Error("The parameter 'skuId' cannot be null.");
        else if (skuId !== undefined)
            url_ += "SkuId=" + encodeURIComponent("" + skuId) + "&";
        if (skuName === null)
            throw new Error("The parameter 'skuName' cannot be null.");
        else if (skuName !== undefined)
            url_ += "SkuName=" + encodeURIComponent("" + skuName) + "&";
        if (requestIds === null)
            throw new Error("The parameter 'requestIds' cannot be null.");
        else if (requestIds !== undefined)
            requestIds && requestIds.forEach(item => { url_ += "RequestIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIds === null)
            throw new Error("The parameter 'productIds' cannot be null.");
        else if (productIds !== undefined)
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (onlyDisabled === null)
            throw new Error("The parameter 'onlyDisabled' cannot be null.");
        else if (onlyDisabled !== undefined)
            url_ += "OnlyDisabled=" + encodeURIComponent("" + onlyDisabled) + "&";
        if (isRequestRequired === null)
            throw new Error("The parameter 'isRequestRequired' cannot be null.");
        else if (isRequestRequired !== undefined)
            url_ += "IsRequestRequired=" + encodeURIComponent("" + isRequestRequired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcelGapRequests(_response);
        });
    }

    protected processDownloadExcelGapRequests(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get GAP request with given id
     * @param requestId Identifier of the GAP request
     * @return OK
     */
    getGapRequest(requestId: number, cancelToken?: CancelToken): Promise<GapRequestGet> {
        let url_ = this.baseUrl + "/v1/gap/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGapRequest(_response);
        });
    }

    protected processGetGapRequest(response: AxiosResponse): Promise<GapRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapRequestGet>(null as any);
    }

    /**
     * Patch a GAP request (partial update)
     * @param requestId Identifier of the GAP request
     * @param body GAP request to patch
     * @return OK
     */
    patchGapRequest(requestId: number, body: GapRequestPatch, cancelToken?: CancelToken): Promise<GapRequestGet> {
        let url_ = this.baseUrl + "/v1/gap/requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPatchGapRequest(_response);
        });
    }

    protected processPatchGapRequest(response: AxiosResponse): Promise<GapRequestGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapRequestGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapRequestGet>(null as any);
    }
}

export class StepsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Get RUC steps for a given fiscal year
     * @param fiscalYear Steps fiscal year
     * @return OK
     */
    getRucSteps(fiscalYear: number, cancelToken?: CancelToken): Promise<RucStepGet[]> {
        let url_ = this.baseUrl + "/v1/ruc/steps?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRucSteps(_response);
        });
    }

    protected processGetRucSteps(response: AxiosResponse): Promise<RucStepGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucStepGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucStepGet[]>(null as any);
    }

    /**
     * Update RUC steps for a fiscal year
     * @param fiscalYear Steps fiscal year
     * @param body RUC steps to update
     * @return OK
     */
    updateRucSteps(fiscalYear: number, body: RucStepCreateOrUpdate[], cancelToken?: CancelToken): Promise<RucStepGet[]> {
        let url_ = this.baseUrl + "/v1/ruc/steps?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRucSteps(_response);
        });
    }

    protected processUpdateRucSteps(response: AxiosResponse): Promise<RucStepGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RucStepGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RucStepGet[]>(null as any);
    }

    /**
     * Get OES steps for a given fiscal year
     * @param fiscalYear Steps fiscal year
     * @return OK
     */
    getOesSteps(fiscalYear: number, cancelToken?: CancelToken): Promise<OesStepGet[]> {
        let url_ = this.baseUrl + "/v1/oes/steps?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOesSteps(_response);
        });
    }

    protected processGetOesSteps(response: AxiosResponse): Promise<OesStepGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesStepGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesStepGet[]>(null as any);
    }

    /**
     * Update OES steps for a fiscal year
     * @param fiscalYear Steps fiscal year
     * @param body OES steps to update
     * @return OK
     */
    updateOesSteps(fiscalYear: number, body: OesStepCreateOrUpdate[], cancelToken?: CancelToken): Promise<OesStepGet[]> {
        let url_ = this.baseUrl + "/v1/oes/steps?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateOesSteps(_response);
        });
    }

    protected processUpdateOesSteps(response: AxiosResponse): Promise<OesStepGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<OesStepGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OesStepGet[]>(null as any);
    }

    /**
     * Get GAP steps for a given fiscal year
     * @param fiscalYear Steps fiscal year
     * @return OK
     */
    getGapSteps(fiscalYear: number, cancelToken?: CancelToken): Promise<GapStepGet[]> {
        let url_ = this.baseUrl + "/v1/gap/steps?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGapSteps(_response);
        });
    }

    protected processGetGapSteps(response: AxiosResponse): Promise<GapStepGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapStepGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapStepGet[]>(null as any);
    }

    /**
     * Update GAP steps for a fiscal year
     * @param fiscalYear Steps fiscal year
     * @param body GAP steps to update
     * @return OK
     */
    updateGapSteps(fiscalYear: number, body: GapStepCreateOrUpdate[], cancelToken?: CancelToken): Promise<GapStepGet[]> {
        let url_ = this.baseUrl + "/v1/gap/steps?";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' must be defined and cannot be null.");
        else
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGapSteps(_response);
        });
    }

    protected processUpdateGapSteps(response: AxiosResponse): Promise<GapStepGet[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GapStepGet[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GapStepGet[]>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create an user
     * @param body User to create
     * @return Created
     */
    createUser(body: UserCreate, cancelToken?: CancelToken): Promise<UserGet> {
        let url_ = this.baseUrl + "/v1/core/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<UserGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<UserGet>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGet>(null as any);
    }

    /**
     * Get paginated user list
     * @param allocationSystemId (optional) 
     * @param search (optional) 
     * @param roleId (optional) 
     * @param permissionTypeId (optional) 
     * @param brandIds (optional) 
     * @param marketIds (optional) 
     * @param includeInactive (optional) 
     * @param page (optional) 
     * @param limit (optional) 
     * @param sort (optional) 
     * @return OK
     */
    getUsers(allocationSystemId?: AllocationSystems | undefined, search?: string | undefined, roleId?: Roles | undefined, permissionTypeId?: PermissionTypes | undefined, brandIds?: number[] | undefined, marketIds?: number[] | undefined, includeInactive?: boolean | undefined, page?: number | undefined, limit?: number | undefined, sort?: SortParameters[] | undefined, cancelToken?: CancelToken): Promise<UserGetIPaginatedList> {
        let url_ = this.baseUrl + "/v1/core/users?";
        if (allocationSystemId === null)
            throw new Error("The parameter 'allocationSystemId' cannot be null.");
        else if (allocationSystemId !== undefined)
            url_ += "AllocationSystemId=" + encodeURIComponent("" + allocationSystemId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (permissionTypeId === null)
            throw new Error("The parameter 'permissionTypeId' cannot be null.");
        else if (permissionTypeId !== undefined)
            url_ += "PermissionTypeId=" + encodeURIComponent("" + permissionTypeId) + "&";
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            sort && sort.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Sort[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<UserGetIPaginatedList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGetIPaginatedList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGetIPaginatedList>(null as any);
    }

    /**
     * Download excel file with users
     * @param allocationSystemId (optional) 
     * @param search (optional) 
     * @param roleId (optional) 
     * @param permissionTypeId (optional) 
     * @param brandIds (optional) 
     * @param marketIds (optional) 
     * @param includeInactive (optional) 
     * @return OK
     */
    downloadExcel(allocationSystemId?: AllocationSystems | undefined, search?: string | undefined, roleId?: Roles | undefined, permissionTypeId?: PermissionTypes | undefined, brandIds?: number[] | undefined, marketIds?: number[] | undefined, includeInactive?: boolean | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/v1/core/users/download/excel?";
        if (allocationSystemId === null)
            throw new Error("The parameter 'allocationSystemId' cannot be null.");
        else if (allocationSystemId !== undefined)
            url_ += "AllocationSystemId=" + encodeURIComponent("" + allocationSystemId) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (permissionTypeId === null)
            throw new Error("The parameter 'permissionTypeId' cannot be null.");
        else if (permissionTypeId !== undefined)
            url_ += "PermissionTypeId=" + encodeURIComponent("" + permissionTypeId) + "&";
        if (brandIds === null)
            throw new Error("The parameter 'brandIds' cannot be null.");
        else if (brandIds !== undefined)
            brandIds && brandIds.forEach(item => { url_ += "BrandIds=" + encodeURIComponent("" + item) + "&"; });
        if (marketIds === null)
            throw new Error("The parameter 'marketIds' cannot be null.");
        else if (marketIds !== undefined)
            marketIds && marketIds.forEach(item => { url_ += "MarketIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadExcel(_response);
        });
    }

    protected processDownloadExcel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get user from requester
     * @return OK
     */
    getMe( cancelToken?: CancelToken): Promise<UserGet> {
        let url_ = this.baseUrl + "/v1/core/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMe(_response);
        });
    }

    protected processGetMe(response: AxiosResponse): Promise<UserGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGet>(null as any);
    }

    /**
     * Get user with given uid (from LDAP)
     * @param uniqueId Unique identifier of user
     * @return OK
     */
    getUser(uniqueId: string, cancelToken?: CancelToken): Promise<UserGet> {
        let url_ = this.baseUrl + "/v1/core/users/{uniqueId}";
        if (uniqueId === undefined || uniqueId === null)
            throw new Error("The parameter 'uniqueId' must be defined.");
        url_ = url_.replace("{uniqueId}", encodeURIComponent("" + uniqueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGet>(null as any);
    }

    /**
     * Update an user
     * @param userId Identifier of the user
     * @param body User properties to update
     * @return OK
     */
    updateUser(userId: number, body: UserUpdate, cancelToken?: CancelToken): Promise<UserGet> {
        let url_ = this.baseUrl + "/v1/core/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UserGet> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserGet>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGet>(null as any);
    }
}

export interface AllocationSystemGet {
    allocationSystemId: AllocationSystems;
    code: string;
    label: string;
    currentFiscalYear: number;
    isDisabled: boolean;
}

export interface AllocationSystemUpdate {
    currentFiscalYear: number;
}

export type AllocationSystems = 1 | 2 | 3 | 4;

export interface BrandCreateOrUpdate {
    code: string;
    label: string;
    organizationId: number | null;
    isDisabled: boolean;
}

export interface BrandGet {
    brandId: number;
    code: string;
    label: string;
    organizationId: number | null;
    isDisabled: boolean;
}

export interface EntityCreateOrUpdate {
    code: string;
    label: string;
    isDisabled: boolean;
}

export interface EntityGet {
    entityId: number;
    code: string;
    label: string;
    isDisabled: boolean;
}

export interface FileGet {
    fileId: number;
    filePath: string;
    fileName: string;
    uploader: number | null;
    uploadDate: string;
    isArchived: boolean;
}

export interface GapFiscalYearProductCreateOrUpdate {
    fiscalYear: number;
    imageIndex: number | null;
    description: string | null;
    createdFileIndexes: number[] | null;
    removedFileIds: number[] | null;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    recommendedFloorConsumerSellingPrice: number | null;
    recommendedFloorConsumerSellingPriceCurrencyId: number | null;
    asiaRecommendedFloorConsumerSellingPrice: number | null;
    asiaRecommendedFloorConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

export interface GapFiscalYearProductGet {
    fiscalYear: number;
    productId: number;
    imageId: number | null;
    image: FileGet;
    description: string | null;
    files: FileGet[] | null;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    recommendedFloorConsumerSellingPrice: number | null;
    recommendedFloorConsumerSellingPriceCurrencyId: number | null;
    asiaRecommendedFloorConsumerSellingPrice: number | null;
    asiaRecommendedFloorConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

export interface GapFiscalYearProductPatch {
    fiscalYear: number;
    description: string | null;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    recommendedFloorConsumerSellingPrice: number | null;
    recommendedFloorConsumerSellingPriceCurrencyId: number | null;
    asiaRecommendedFloorConsumerSellingPrice: number | null;
    asiaRecommendedFloorConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

/** See  model. */
export interface GapProductCreateOrUpdate {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: GapFiscalYearProductCreateOrUpdate[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    strength: string | null;
}

export interface GapProductGet {
    productId: number;
    allocationSystemId: AllocationSystems;
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: ProductUserGet;
    disabledBy: number | null;
    disabledDate: string | null;
    disabler: ProductUserGet;
    fiscalYearProducts: GapFiscalYearProductGet[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    strength: string | null;
}

export interface GapProductGetIPaginatedList {
    readonly items: GapProductGet[] | null;
    readonly totalItems: number;
}

export interface GapProductPatch {
    brandId: number | null;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: GapFiscalYearProductPatch[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    strength: string | null;
}

export interface GapRequestCreate {
    fiscalYear: number;
    productId: number;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    requestedQuantity: number | null;
    mrRequestedQuantity: number | null;
    validatedQuantity: number | null;
    mrValidatedQuantity: number | null;
    requestedQuantityH1Fy1: number | null;
    validatedQuantityH1Fy1: number | null;
    requestedQuantityH2Fy1: number | null;
    validatedQuantityH2Fy1: number | null;
    requestedQuantityH1Fy2: number | null;
    validatedQuantityH1Fy2: number | null;
    requestedQuantityH2Fy2: number | null;
    validatedQuantityH2Fy2: number | null;
    currentFullYearAllocation: number | null;
}

export interface GapRequestGet {
    requestId: number;
    fiscalYear: number;
    productId: number;
    product: GapProductGet;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: RequestUserGet;
    previousRequestedQuantity: number | null;
    previousMrRequestedQuantity: number | null;
    previousValidatedQuantity: number | null;
    previousMrValidatedQuantity: number | null;
    requestedQuantity: number | null;
    mrRequestedQuantity: number | null;
    validatedQuantity: number | null;
    mrValidatedQuantity: number | null;
    requestedQuantityH1Fy1: number | null;
    validatedQuantityH1Fy1: number | null;
    requestedQuantityH2Fy1: number | null;
    validatedQuantityH2Fy1: number | null;
    requestedQuantityH1Fy2: number | null;
    validatedQuantityH1Fy2: number | null;
    requestedQuantityH2Fy2: number | null;
    validatedQuantityH2Fy2: number | null;
    currentFullYearAllocation: number | null;
}

export interface GapRequestGetIPaginatedList {
    readonly items: GapRequestGet[] | null;
    readonly totalItems: number;
}

export interface GapRequestPatch {
    brandComment: string | null;
    marketComment: string | null;
    requestedQuantity: number | null;
    mrRequestedQuantity: number | null;
    validatedQuantity: number | null;
    mrValidatedQuantity: number | null;
    requestedQuantityH1Fy1: number | null;
    validatedQuantityH1Fy1: number | null;
    requestedQuantityH2Fy1: number | null;
    validatedQuantityH2Fy1: number | null;
    requestedQuantityH1Fy2: number | null;
    validatedQuantityH1Fy2: number | null;
    requestedQuantityH2Fy2: number | null;
    validatedQuantityH2Fy2: number | null;
    currentFullYearAllocation: number | null;
}

export interface GapStepCreateOrUpdate {
    order: StepOrders;
    isMidYearReview: boolean;
    label: string | null;
    startDate: string;
    endDate: string;
}

export interface GapStepGet {
    fiscalYear: number;
    order: StepOrders;
    isMidYearReview: boolean;
    label: string | null;
    startDate: string;
    endDate: string;
}

export interface ImportGet {
    fileId: number;
    allocationSystemId: AllocationSystems;
    fiscalYear: number;
    importStatusId: ImportStatus;
    createdRows: number | null;
    updatedRows: number | null;
    startDate: string;
    endDate: string | null;
    errors: string[] | null;
}

export type ImportStatus = 1 | 2 | 3 | 4 | 5;

export interface LoiFiscalYearProductBarcodeDto {
    label: string | null;
    code: string | null;
}

export interface LoiFiscalYearProductCreateOrUpdate {
    fiscalYear: number;
    imageIndex: number | null;
    description: string | null;
    createdFileIndexes: number[] | null;
    removedFileIds: number[] | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    areJanuaryRequestsAllowed: boolean;
    areFebruaryRequestsAllowed: boolean;
    areMarchRequestsAllowed: boolean;
    areAprilRequestsAllowed: boolean;
    areMayRequestsAllowed: boolean;
    areJuneRequestsAllowed: boolean;
    areJulyRequestsAllowed: boolean;
    areAugustRequestsAllowed: boolean;
    areSeptemberRequestsAllowed: boolean;
    areOctoberRequestsAllowed: boolean;
    areNovemberRequestsAllowed: boolean;
    areDecemberRequestsAllowed: boolean;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
    otherBarcodeRequirements: string | null;
    marketSpecificRequirements: string | null;
    fiscalYearProductBarcodes: LoiFiscalYearProductBarcodeDto[] | null;
}

export interface LoiFiscalYearProductGet {
    fiscalYear: number;
    productId: number;
    imageId: number | null;
    image: FileGet;
    description: string | null;
    files: FileGet[] | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    areJanuaryRequestsAllowed: boolean;
    areFebruaryRequestsAllowed: boolean;
    areMarchRequestsAllowed: boolean;
    areAprilRequestsAllowed: boolean;
    areMayRequestsAllowed: boolean;
    areJuneRequestsAllowed: boolean;
    areJulyRequestsAllowed: boolean;
    areAugustRequestsAllowed: boolean;
    areSeptemberRequestsAllowed: boolean;
    areOctoberRequestsAllowed: boolean;
    areNovemberRequestsAllowed: boolean;
    areDecemberRequestsAllowed: boolean;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
    otherBarcodeRequirements: string | null;
    marketSpecificRequirements: string | null;
    fiscalYearProductBarcodes: LoiFiscalYearProductBarcodeDto[] | null;
}

export interface LoiFiscalYearProductPatch {
    fiscalYear: number;
    description: string | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    areJanuaryRequestsAllowed: boolean;
    areFebruaryRequestsAllowed: boolean;
    areMarchRequestsAllowed: boolean;
    areAprilRequestsAllowed: boolean;
    areMayRequestsAllowed: boolean;
    areJuneRequestsAllowed: boolean;
    areJulyRequestsAllowed: boolean;
    areAugustRequestsAllowed: boolean;
    areSeptemberRequestsAllowed: boolean;
    areOctoberRequestsAllowed: boolean;
    areNovemberRequestsAllowed: boolean;
    areDecemberRequestsAllowed: boolean;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
    otherBarcodeRequirements: string | null;
    marketSpecificRequirements: string | null;
    fiscalYearProductBarcodes: LoiFiscalYearProductBarcodeDto[] | null;
}

/** See  model. */
export interface LoiProductCreateOrUpdate {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: LoiFiscalYearProductCreateOrUpdate[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface LoiProductGet {
    productId: number;
    allocationSystemId: AllocationSystems;
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: ProductUserGet;
    disabledBy: number | null;
    disabledDate: string | null;
    disabler: ProductUserGet;
    fiscalYearProducts: LoiFiscalYearProductGet[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface LoiProductGetIPaginatedList {
    readonly items: LoiProductGet[] | null;
    readonly totalItems: number;
}

export interface LoiProductPatch {
    brandId: number | null;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: LoiFiscalYearProductPatch[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface LoiRequestCreate {
    fiscalYear: number;
    productId: number;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    januaryRequestedQuantity: number | null;
    februaryRequestedQuantity: number | null;
    marchRequestedQuantity: number | null;
    aprilRequestedQuantity: number | null;
    mayRequestedQuantity: number | null;
    juneRequestedQuantity: number | null;
    julyRequestedQuantity: number | null;
    augustRequestedQuantity: number | null;
    septemberRequestedQuantity: number | null;
    octoberRequestedQuantity: number | null;
    novemberRequestedQuantity: number | null;
    decemberRequestedQuantity: number | null;
    januaryValidatedQuantity: number | null;
    februaryValidatedQuantity: number | null;
    marchValidatedQuantity: number | null;
    aprilValidatedQuantity: number | null;
    mayValidatedQuantity: number | null;
    juneValidatedQuantity: number | null;
    julyValidatedQuantity: number | null;
    augustValidatedQuantity: number | null;
    septemberValidatedQuantity: number | null;
    octoberValidatedQuantity: number | null;
    novemberValidatedQuantity: number | null;
    decemberValidatedQuantity: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
}

export interface LoiRequestGet {
    requestId: number;
    fiscalYear: number;
    productId: number;
    product: LoiProductGet;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: RequestUserGet;
    januaryRequestedQuantity: number | null;
    februaryRequestedQuantity: number | null;
    marchRequestedQuantity: number | null;
    aprilRequestedQuantity: number | null;
    mayRequestedQuantity: number | null;
    juneRequestedQuantity: number | null;
    julyRequestedQuantity: number | null;
    augustRequestedQuantity: number | null;
    septemberRequestedQuantity: number | null;
    octoberRequestedQuantity: number | null;
    novemberRequestedQuantity: number | null;
    decemberRequestedQuantity: number | null;
    januaryValidatedQuantity: number | null;
    februaryValidatedQuantity: number | null;
    marchValidatedQuantity: number | null;
    aprilValidatedQuantity: number | null;
    mayValidatedQuantity: number | null;
    juneValidatedQuantity: number | null;
    julyValidatedQuantity: number | null;
    augustValidatedQuantity: number | null;
    septemberValidatedQuantity: number | null;
    octoberValidatedQuantity: number | null;
    novemberValidatedQuantity: number | null;
    decemberValidatedQuantity: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
}

export interface LoiRequestGetIPaginatedList {
    readonly items: LoiRequestGet[] | null;
    readonly totalItems: number;
}

export interface LoiRequestPatch {
    brandComment: string | null;
    marketComment: string | null;
    januaryRequestedQuantity: number | null;
    februaryRequestedQuantity: number | null;
    marchRequestedQuantity: number | null;
    aprilRequestedQuantity: number | null;
    mayRequestedQuantity: number | null;
    juneRequestedQuantity: number | null;
    julyRequestedQuantity: number | null;
    augustRequestedQuantity: number | null;
    septemberRequestedQuantity: number | null;
    octoberRequestedQuantity: number | null;
    novemberRequestedQuantity: number | null;
    decemberRequestedQuantity: number | null;
    januaryValidatedQuantity: number | null;
    februaryValidatedQuantity: number | null;
    marchValidatedQuantity: number | null;
    aprilValidatedQuantity: number | null;
    mayValidatedQuantity: number | null;
    juneValidatedQuantity: number | null;
    julyValidatedQuantity: number | null;
    augustValidatedQuantity: number | null;
    septemberValidatedQuantity: number | null;
    octoberValidatedQuantity: number | null;
    novemberValidatedQuantity: number | null;
    decemberValidatedQuantity: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
}

export interface MarketCreateOrUpdate {
    code: string;
    label: string;
    entityId: number | null;
    isDisabled: boolean;
}

export interface MarketGet {
    marketId: number;
    code: string;
    label: string;
    entityId: number | null;
    isDisabled: boolean;
}

export interface OesFiscalYearProductCreateOrUpdate {
    fiscalYear: number;
    imageIndex: number | null;
    description: string | null;
    createdFileIndexes: number[] | null;
    removedFileIds: number[] | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    areJanuaryRequestsAllowed: boolean;
    areFebruaryRequestsAllowed: boolean;
    areMarchRequestsAllowed: boolean;
    areAprilRequestsAllowed: boolean;
    areMayRequestsAllowed: boolean;
    areJuneRequestsAllowed: boolean;
    areJulyRequestsAllowed: boolean;
    areAugustRequestsAllowed: boolean;
    areSeptemberRequestsAllowed: boolean;
    areOctoberRequestsAllowed: boolean;
    areNovemberRequestsAllowed: boolean;
    areDecemberRequestsAllowed: boolean;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

export interface OesFiscalYearProductGet {
    fiscalYear: number;
    productId: number;
    imageId: number | null;
    image: FileGet;
    description: string | null;
    files: FileGet[] | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    areJanuaryRequestsAllowed: boolean;
    areFebruaryRequestsAllowed: boolean;
    areMarchRequestsAllowed: boolean;
    areAprilRequestsAllowed: boolean;
    areMayRequestsAllowed: boolean;
    areJuneRequestsAllowed: boolean;
    areJulyRequestsAllowed: boolean;
    areAugustRequestsAllowed: boolean;
    areSeptemberRequestsAllowed: boolean;
    areOctoberRequestsAllowed: boolean;
    areNovemberRequestsAllowed: boolean;
    areDecemberRequestsAllowed: boolean;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

export interface OesFiscalYearProductPatch {
    fiscalYear: number;
    description: string | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    areJanuaryRequestsAllowed: boolean;
    areFebruaryRequestsAllowed: boolean;
    areMarchRequestsAllowed: boolean;
    areAprilRequestsAllowed: boolean;
    areMayRequestsAllowed: boolean;
    areJuneRequestsAllowed: boolean;
    areJulyRequestsAllowed: boolean;
    areAugustRequestsAllowed: boolean;
    areSeptemberRequestsAllowed: boolean;
    areOctoberRequestsAllowed: boolean;
    areNovemberRequestsAllowed: boolean;
    areDecemberRequestsAllowed: boolean;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

/** See  model. */
export interface OesProductCreateOrUpdate {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: OesFiscalYearProductCreateOrUpdate[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface OesProductGet {
    productId: number;
    allocationSystemId: AllocationSystems;
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: ProductUserGet;
    disabledBy: number | null;
    disabledDate: string | null;
    disabler: ProductUserGet;
    fiscalYearProducts: OesFiscalYearProductGet[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface OesProductGetIPaginatedList {
    readonly items: OesProductGet[] | null;
    readonly totalItems: number;
}

export interface OesProductPatch {
    brandId: number | null;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: OesFiscalYearProductPatch[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface OesRequestCreate {
    fiscalYear: number;
    productId: number;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    januaryRequestedQuantity: number | null;
    februaryRequestedQuantity: number | null;
    marchRequestedQuantity: number | null;
    aprilRequestedQuantity: number | null;
    mayRequestedQuantity: number | null;
    juneRequestedQuantity: number | null;
    julyRequestedQuantity: number | null;
    augustRequestedQuantity: number | null;
    septemberRequestedQuantity: number | null;
    octoberRequestedQuantity: number | null;
    novemberRequestedQuantity: number | null;
    decemberRequestedQuantity: number | null;
    januaryValidatedQuantity: number | null;
    februaryValidatedQuantity: number | null;
    marchValidatedQuantity: number | null;
    aprilValidatedQuantity: number | null;
    mayValidatedQuantity: number | null;
    juneValidatedQuantity: number | null;
    julyValidatedQuantity: number | null;
    augustValidatedQuantity: number | null;
    septemberValidatedQuantity: number | null;
    octoberValidatedQuantity: number | null;
    novemberValidatedQuantity: number | null;
    decemberValidatedQuantity: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
}

export interface OesRequestGet {
    requestId: number;
    fiscalYear: number;
    productId: number;
    product: OesProductGet;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: RequestUserGet;
    januaryRequestedQuantity: number | null;
    februaryRequestedQuantity: number | null;
    marchRequestedQuantity: number | null;
    aprilRequestedQuantity: number | null;
    mayRequestedQuantity: number | null;
    juneRequestedQuantity: number | null;
    julyRequestedQuantity: number | null;
    augustRequestedQuantity: number | null;
    septemberRequestedQuantity: number | null;
    octoberRequestedQuantity: number | null;
    novemberRequestedQuantity: number | null;
    decemberRequestedQuantity: number | null;
    januaryValidatedQuantity: number | null;
    februaryValidatedQuantity: number | null;
    marchValidatedQuantity: number | null;
    aprilValidatedQuantity: number | null;
    mayValidatedQuantity: number | null;
    juneValidatedQuantity: number | null;
    julyValidatedQuantity: number | null;
    augustValidatedQuantity: number | null;
    septemberValidatedQuantity: number | null;
    octoberValidatedQuantity: number | null;
    novemberValidatedQuantity: number | null;
    decemberValidatedQuantity: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
}

export interface OesRequestGetIPaginatedList {
    readonly items: OesRequestGet[] | null;
    readonly totalItems: number;
}

export interface OesRequestPatch {
    brandComment: string | null;
    marketComment: string | null;
    januaryRequestedQuantity: number | null;
    februaryRequestedQuantity: number | null;
    marchRequestedQuantity: number | null;
    aprilRequestedQuantity: number | null;
    mayRequestedQuantity: number | null;
    juneRequestedQuantity: number | null;
    julyRequestedQuantity: number | null;
    augustRequestedQuantity: number | null;
    septemberRequestedQuantity: number | null;
    octoberRequestedQuantity: number | null;
    novemberRequestedQuantity: number | null;
    decemberRequestedQuantity: number | null;
    januaryValidatedQuantity: number | null;
    februaryValidatedQuantity: number | null;
    marchValidatedQuantity: number | null;
    aprilValidatedQuantity: number | null;
    mayValidatedQuantity: number | null;
    juneValidatedQuantity: number | null;
    julyValidatedQuantity: number | null;
    augustValidatedQuantity: number | null;
    septemberValidatedQuantity: number | null;
    octoberValidatedQuantity: number | null;
    novemberValidatedQuantity: number | null;
    decemberValidatedQuantity: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
}

export interface OesStepCreateOrUpdate {
    order: StepOrders;
    isMidYearReview: boolean;
    label: string | null;
    startDate: string;
    endDate: string;
}

export interface OesStepGet {
    fiscalYear: number;
    isMidYearReview: boolean;
    order: StepOrders;
    label: string | null;
    startDate: string;
    endDate: string;
}

export interface OrganizationCreateOrUpdate {
    code: string;
    label: string;
    isDisabled: boolean;
}

export interface OrganizationGet {
    organizationId: number;
    code: string;
    label: string;
    isDisabled: boolean;
}

export interface PermissionCreateOrUpdate {
    allocationSystemId: AllocationSystems;
    roleId: Roles;
    permissionTypeId: PermissionTypes;
    ids: number[] | null;
}

export interface PermissionGet {
    allocationSystemId: AllocationSystems;
    roleId: Roles;
    permissionTypeId: PermissionTypes;
    ids: number[] | null;
}

export type PermissionTypes = 1 | 2;

export interface ProductUserGet {
    userId: number;
    email: string | null;
    name: string | null;
}

export interface RequestUserGet {
    userId: number;
    email: string | null;
    name: string | null;
}

export type Roles = 1 | 2 | 3;

export interface RucFiscalYearProductCreateOrUpdate {
    fiscalYear: number;
    imageIndex: number | null;
    description: string | null;
    createdFileIndexes: number[] | null;
    removedFileIds: number[] | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    launchDate: string | null;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    minimumProfitability: number | null;
    minimumProfitabilityCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

export interface RucFiscalYearProductGet {
    fiscalYear: number;
    productId: number;
    imageId: number | null;
    image: FileGet;
    description: string | null;
    files: FileGet[] | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    launchDate: string | null;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    minimumProfitability: number | null;
    minimumProfitabilityCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

export interface RucFiscalYearProductPatch {
    fiscalYear: number;
    description: string | null;
    startOrderPeriod: string | null;
    endOrderPeriod: string | null;
    launchDate: string | null;
    availableQuantity: number | null;
    availableQuantityN1: number | null;
    availableQuantityN2: number | null;
    minimumOrderQuantity: number | null;
    recommendedConsumerSellingPrice: number | null;
    recommendedConsumerSellingPriceCurrencyId: number | null;
    minimumProfitability: number | null;
    minimumProfitabilityCurrencyId: number | null;
    lastFiscalYearNetSales: number | null;
    lastFiscalYearNetSalesCurrencyId: number | null;
}

/** See  model. */
export interface RucProductCreateOrUpdate {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: RucFiscalYearProductCreateOrUpdate[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface RucProductGet {
    productId: number;
    allocationSystemId: AllocationSystems;
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: ProductUserGet;
    disabledBy: number | null;
    disabledDate: string | null;
    disabler: ProductUserGet;
    fiscalYearProducts: RucFiscalYearProductGet[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface RucProductGetIPaginatedList {
    readonly items: RucProductGet[] | null;
    readonly totalItems: number;
}

export interface RucProductPatch {
    brandId: number | null;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: RucFiscalYearProductPatch[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface RucRequestCreate {
    fiscalYear: number;
    productId: number;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    requestedQuantity: number | null;
    mrRequestedQuantity: number | null;
    validatedQuantity: number | null;
    mrValidatedQuantity: number | null;
    requestedQuantityH1Fy1: number | null;
    validatedQuantityH1Fy1: number | null;
    requestedQuantityH2Fy1: number | null;
    validatedQuantityH2Fy1: number | null;
    requestedQuantityH1Fy2: number | null;
    validatedQuantityH1Fy2: number | null;
    requestedQuantityH2Fy2: number | null;
    validatedQuantityH2Fy2: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
    currentFullYearAllocation: number | null;
}

export interface RucRequestGet {
    requestId: number;
    fiscalYear: number;
    productId: number;
    product: RucProductGet;
    marketId: number;
    brandComment: string | null;
    marketComment: string | null;
    updatedBy: number;
    updatedDate: string;
    updater: RequestUserGet;
    previousRequestedQuantity: number | null;
    previousMrRequestedQuantity: number | null;
    previousValidatedQuantity: number | null;
    previousMrValidatedQuantity: number | null;
    requestedQuantity: number | null;
    mrRequestedQuantity: number | null;
    validatedQuantity: number | null;
    mrValidatedQuantity: number | null;
    requestedQuantityH1Fy1: number | null;
    validatedQuantityH1Fy1: number | null;
    requestedQuantityH2Fy1: number | null;
    validatedQuantityH2Fy1: number | null;
    requestedQuantityH1Fy2: number | null;
    validatedQuantityH1Fy2: number | null;
    requestedQuantityH2Fy2: number | null;
    validatedQuantityH2Fy2: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
    currentFullYearAllocation: number | null;
}

export interface RucRequestGetIPaginatedList {
    readonly items: RucRequestGet[] | null;
    readonly totalItems: number;
}

export interface RucRequestPatch {
    brandComment: string | null;
    marketComment: string | null;
    requestedQuantity: number | null;
    mrRequestedQuantity: number | null;
    validatedQuantity: number | null;
    mrValidatedQuantity: number | null;
    requestedQuantityH1Fy1: number | null;
    validatedQuantityH1Fy1: number | null;
    requestedQuantityH2Fy1: number | null;
    validatedQuantityH2Fy1: number | null;
    requestedQuantityH1Fy2: number | null;
    validatedQuantityH1Fy2: number | null;
    requestedQuantityH2Fy2: number | null;
    validatedQuantityH2Fy2: number | null;
    d2CEstimatedShare: number | null;
    estimatedConsumerSellingPrice: number | null;
    estimatedConsumerSellingPriceCurrencyId: number | null;
    currentFullYearAllocation: number | null;
}

export interface RucStepCreateOrUpdate {
    order: StepOrders;
    isMidYearReview: boolean;
    label: string | null;
    startDate: string;
    endDate: string;
}

export interface RucStepGet {
    fiscalYear: number;
    order: StepOrders;
    isMidYearReview: boolean;
    label: string | null;
    startDate: string;
    endDate: string;
}

export interface SortParameters {
    column: string | null;
    isAscendant: boolean;
}

export type StepOrders = 1 | 2 | 3;

export interface UserCreate {
    uniqueId: string;
    email: string;
    name: string;
    isActive: boolean;
    isGlobalAdministrator: boolean;
    permissions: PermissionCreateOrUpdate[] | null;
}

export interface UserGet {
    userId: number;
    uniqueId: string;
    email: string;
    name: string;
    isGlobalAdministrator: boolean;
    isActive: boolean;
    permissions: PermissionGet[] | null;
}

export interface UserGetIPaginatedList {
    readonly items: UserGet[] | null;
    readonly totalItems: number;
}

export interface UserUpdate {
    email: string;
    name: string;
    isActive: boolean;
    isGlobalAdministrator: boolean;
    permissions: PermissionCreateOrUpdate[] | null;
}

export interface ProductCreateOrUpdateData {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: RucFiscalYearProductCreateOrUpdate[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData2 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: RucFiscalYearProductCreateOrUpdate[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData3 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: OesFiscalYearProductCreateOrUpdate[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData4 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: OesFiscalYearProductCreateOrUpdate[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData5 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: LoiFiscalYearProductCreateOrUpdate[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData6 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: LoiFiscalYearProductCreateOrUpdate[] | null;
    name: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    setOfUnits: number | null;
    pack: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData7 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: GapFiscalYearProductCreateOrUpdate[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    strength: string | null;
}

export interface ProductCreateOrUpdateData8 {
    brandId: number;
    contactEmail: string | null;
    link: string | null;
    fiscalYearProducts: GapFiscalYearProductCreateOrUpdate[] | null;
    skuId: string | null;
    skuName: string | null;
    formatSize: number | null;
    formatUnit: string | null;
    strength: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}